/** Máscara de celular: (11) 94729-3221 */
export function maskBrazilMobile(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  if (digits.length === 0) return "";
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

export function isBrazilMobile(value: string): boolean {
  return /^\([1-9]{2}\) 9\d{4}-\d{4}$/.test(value);
}
